// extracted by mini-css-extract-plugin
module.exports = {"content":"Hero-module--content--fRIO_","h1":"Hero-module--h1--1t3TL","subheader":"Hero-module--subheader--2VAG9"};